<template>
  <div class="on-focus__popular-queries-container q-text-dark" v-if="hasPopularQueries">
    <div class="on-focus__popular-queries-content q-row">
      <QueriesContainer :queries="getPopularQueries"
                        :queries-header="SmartSearchTranslations.popularQueries.header"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import QueriesContainer from '../Queries/QueriesContainer.vue'

import {onMounted, inject} from "vue";
import {storeToRefs} from "pinia";
import {usePopularQueriesStore} from "@/store/AutocompletePopup/PopularQueriesStore";
import {SmartSearchTranslationsInterface} from "@/core/types";


const popularQueriesStore = usePopularQueriesStore()
const {getPopularQueries, hasPopularQueries} = storeToRefs(popularQueriesStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
onMounted(async () => {
  await popularQueriesStore.fetchPopularQueries()
})

</script>

<style scoped>
a {
  cursor: pointer;
}
</style>